import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

export default function useMutationUploadFavicon() {
	return useMutation({
		mutationFn: (file: File) => FileService.uploadFavicon(file),
	})
}
